import * as React from 'react';
import { LinkIcon } from '../Icons';
import './Heading.styles.scss';

export interface HeadingProps {
  children: string;
  type: 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

type MaybeString = string | undefined;

/**
 * Converts inner HTML text with custom ID and class name syntax into an object
 * that returns the ID, class name, and inner text
 */
const parseHeading = (
  val: string | string[]
): { id?: string; className?: string; text: string } => {
  let id: MaybeString,
    className: MaybeString,
    text = '';

  let t = Array.isArray(val) ? val.find((i) => typeof i === 'string') : val;
  const isCustom = t?.match(/\{([^)]+)\}/) || [];
  text = t?.split('{')[0]?.trim() || '';

  // Handle custom id or classname found inside brackets
  if (isCustom.length) {
    const s = isCustom[1][0];
    id = s === '#' ? isCustom[1].split(s)[1] : undefined;
    className = s === '.' ? isCustom[1].split(s)[1] : undefined;
  }

  // Handle default id generation
  if (!id && text) {
    id = text
      .toLowerCase()
      .replace(/[^-a-z0-9 ]/g, '')
      .replace(/[ ]/g, '-');
  }

  return { id, className, text };
};

export const Heading = ({ children, type }: HeadingProps) => {
  const [isCopied, setIsCopied] = React.useState(false);
  const { id, className, text } = parseHeading(children);

  function copyToClipboard(value?: string) {
    if (!value) return;
    const path = window.location.href.split('#')[0];
    navigator.clipboard.writeText(`${path}#${value}`);
  }

  return (
    <div className="mdx-heading">
      {React.createElement(
        type,
        { id, className },
        <>
          {text}
          {type === 'h2' || type === 'h3' ? (
            <button
              className="flex align-center"
              onClick={() => {
                copyToClipboard(id);
                setIsCopied(true);
                setTimeout(() => setIsCopied(false), 3000);
              }}>
              <LinkIcon />
              <span className={isCopied ? 'active' : undefined}>
                Copied URL
              </span>
            </button>
          ) : null}
        </>
      )}
    </div>
  );
};
